import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar"; // Snackbar import kiya
import axios from "axios";

import { clearSelectedOrg, clearResults } from "../../../../../features/OrgAdmin/orgAdminSlice";
import FilterOrg from "../../OrgAmin/components/FilterOrg";

function GenVehicleReport() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  
  // Snackbar States
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const today = new Date().toISOString().split('T')[0];
  const [selectedDate, setSelectedDate] = useState(today);

  const { selectedOrg } = useSelector((state) => state.org);
  const orgId = selectedOrg?.orgInfo?.orgHandle || "";

  // Snackbar open/close handlers
  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  const fetchVehicleData = async () => {
    if (!orgId) return;
    setLoading(true);

    try {
      await axios.get(`https://v6.dhundhoo.com/distanceCalculator/${selectedDate}?orgId=${orgId}`);
      openSuccessSB(); // Success snackbar dikhao
    } catch (err) {
      setErrorMessage("Failed to generate report. Please try again.");
      openErrorSB(); // Error snackbar dikhao
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    dispatch(clearSelectedOrg());
    dispatch(clearResults());
    setSelectedDate(today);
  };

  return (
    <MDBox py={3}>

      <MDBox display="flex" flexDirection="column" alignItems="center" gap={3}>
        {orgId ? (
          <MDBox display="flex" flexDirection="column" alignItems="center" gap={2}>
            <MDTypography variant="h6">Select date:</MDTypography>
            
            <MDInput 
              type="date" 
              value={selectedDate} 
              onChange={(e) => setSelectedDate(e.target.value)} 
              sx={{ width: "250px" }}
            />

            <MDBox display="flex" gap={2}>
              <MDButton 
                variant="gradient" 
                color="info" 
                onClick={fetchVehicleData}
                disabled={loading}
              >
                {loading ? "Generating..." : "Generate Report"}
              </MDButton>

              <MDButton 
                variant="outlined" 
                color="secondary" 
                onClick={handleClear}
              >
                Clear
              </MDButton>
            </MDBox>
          </MDBox>
        ) : (
          <MDTypography variant="h6" color="secondary" opacity={0.7}>
            Please select organization to proceed
          </MDTypography>
        )}
      </MDBox>

      {/* --- SNACKBARS --- */}
      
      {/* Success Snackbar */}
      <MDSnackbar
        color="success"
        icon="check"
        title="Success"
        content="Report generated successfully!"
        dateTime="Just now"
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />

      {/* Error Snackbar */}
      <MDSnackbar
        color="error"
        icon="warning"
        title="Error"
        content={errorMessage}
        dateTime="Just now"
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    </MDBox>
  );
}

export default GenVehicleReport;